var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0303 10.2911H12.4242C12.3357 10.2911 12.263 10.3214 12.2065 10.3821C12.1495 10.4426 12.1212 10.52 12.1212 10.6143V13.8466C12.1212 14.2911 11.9729 14.6715 11.6762 14.9881C11.3795 15.3045 11.0228 15.4626 10.6061 15.4626H2.72721C2.31055 15.4626 1.95383 15.3045 1.65708 14.9881C1.36039 14.6715 1.21206 14.2911 1.21206 13.8466V5.44256C1.21206 4.99812 1.36035 4.61776 1.65708 4.30125C1.95383 3.98471 2.31055 3.82653 2.72721 3.82653H6.76056C6.84908 3.82653 6.92172 3.79614 6.97847 3.73561C7.03522 3.675 7.06358 3.59763 7.06358 3.50327V2.85671C7.06358 2.76253 7.03522 2.68501 6.97847 2.62451C6.92172 2.56391 6.84908 2.53366 6.76056 2.53366H2.72721C1.97602 2.53366 1.33362 2.81818 0.80008 3.38719C0.266738 3.95616 0 4.64139 0 5.44267V13.8468C0 14.648 0.266737 15.3334 0.800113 15.9022C1.33365 16.4712 1.97605 16.7559 2.72724 16.7559H10.6061C11.3572 16.7559 11.9997 16.4712 12.5332 15.9022C13.0667 15.3334 13.3334 14.6481 13.3334 13.8468V10.6146C13.3334 10.5202 13.305 10.4427 13.2481 10.3821C13.1912 10.3214 13.1186 10.2911 13.0303 10.2911Z",
    fill: "#00C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65225 1.97724V0.75586L16 0.755859L16 8.27573H14.8066V1.97724H8.65225Z",
    fill: "#00C0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6276 1.15508C15.8548 1.3876 15.8548 1.76461 15.6276 1.99713L6.22937 11.6155C6.00217 11.848 5.6338 11.848 5.40659 11.6155C5.17939 11.383 5.17939 11.006 5.40659 10.7735L14.8048 1.15508C15.032 0.92255 15.4004 0.92255 15.6276 1.15508Z",
    fill: "#00C0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.472d6e1352469e484da09c6df87564f7.svg";
export { ForwardRef as ReactComponent };